export default "__VITE_PUBLIC_ASSET__472bd569__"